import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/_base/base.component';
import { Navigator } from 'src/app/_models';

@Component({
  selector: 'app-navigator',
  templateUrl: './navigator.component.html',
  styleUrls: ['./navigator.component.scss']
})
export class NavigatorComponent extends BaseComponent implements OnInit {
  @Input()
  navigatorManu: Navigator[] = [];
  constructor(private router: Router) {
    super();
  }

  ngOnInit() {}
  getActive(menuItem: Navigator): boolean {
    return menuItem.mainRouteName ? this.router.url.includes(menuItem.mainRouteName) : false;
  }
  goTo(menuItem: Navigator): void {
    if (menuItem.routerUrl) this.router.navigate([menuItem.routerUrl]);
  }
}
